<template>
  <div>
    <create-card route_back="EmployeeList" model_name="funcionário" :saving="saving">
      <template slot="form">
        <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0">
          <v-stepper-step :complete="stepper > 0" step="0" :editable="stepper > 0"> 
            Idenficação 
            <small>Nome e documentos</small>
          </v-stepper-step>
          <v-stepper-content :complete="stepper > 0" step="0">
            <employee-info-form ref="form0"  @changeStepper="handleChangeStepper" :employee="employee"></employee-info-form>
          </v-stepper-content>

          <v-stepper-step :complete="stepper > 1" step="1" :editable="stepper > 1">
            Contatos
          </v-stepper-step>
          <v-stepper-content step="1">
            <StepperManyContacts :limit="2" ref="form1" @changeStepper="handleChangeStepper" :model="employee"></StepperManyContacts>
          </v-stepper-content>

          <v-stepper-step :complete="stepper > 2" step="2" :editable="stepper > 2">
            Endereço <small>Digite o CEP para prenchimento automático</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <StepperAddress ref="form2" one_address @changeStepper="handleChangeStepper" :model="employee"></StepperAddress>
          </v-stepper-content>

          <v-stepper-step :complete="stepper > 3" step="3" :editable="stepper > 3">
            Cargo, Salário e Comissão
          </v-stepper-step>
          <v-stepper-content step="3">
            <employee-salary-form ref="form3" @changeStepper="handleChangeStepper" :employee="employee"></employee-salary-form>
          </v-stepper-content>

          <v-stepper-step step="4" :editable="stepper > 4">Dados Bancários</v-stepper-step>
          <v-stepper-content step="4">
            <employee-bank-form ref="form4" @changeStepper="handleChangeStepper" :employee="employee"></employee-bank-form>
          </v-stepper-content>
        </v-stepper>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name:"CreateEmployee",

  components: {
    CreateCard: ()=> import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    StepperManyContacts: () => import("@/_backoffice/_registrations/components/shared/forms/steppers/StepperManyContacts.vue"),
    StepperAddress: () => import("@/_backoffice/_registrations/components/shared/forms/steppers/StepperAddress.vue"),
    EmployeeBankForm: () => import("./stepper/EmployeeBankStepper.vue"),
    EmployeeInfoForm: () => import("./stepper/EmployeeInfoStepper.vue"),
    EmployeeSalaryForm: () => import("./forms/EmployeeSalaryForm.vue"),
  },
  data() {
    return {
      stepper: 0,
      saving:false,
      employee: {
        status_id: 1,
        manager_id: null,
        team: 'none',
        comissions_attributes: [],
        modality_ids: [],
        goals_attributes: {
          goal: null,
          status_id: 'Set',
          due_date: new Date((new Date).getUTCFullYear(), (new Date).getUTCMonth() + 1, 0).toISOString().substring(0, 10),
          comment: 'Meta ao criar employee',
          kind: null,
          name: null,
          actual_value: 0,
        },
        user_attributes: {
          name: null,
          cpf: null,
          email: null,
          password: '4826#webcimentao@',
          password_confirmation: '4826#webcimentao@',
        },
        address_attributes: {
          zip: '',
          city: '',
          complement: '',
          neighborhood: '',
          addr: '',
          uf: '',
          number: '',
        },
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
        contacts_attributes: [],
        accounts_attributes: [],
        driver_attributes: {
          name: null,
          cnh: null,
          // documents: null,
          truck_id: null,
          external: null,
          status_id: null,
          modality_ids: []
        },
        contacts: {
          primary: {
            email: '',
            phone: '',
            mobile: '',
          },
          secondary: {
            email: '',
            phone: '',
            mobile: '',
          },
        },
        accounts: {
          primary: {
            bank: '',
            agency: '',
            account: '',
            titular: '',
            titularCPF: '',
          },
          secondary: {
            bank: '',
            agency: '',
            account: '',
            titular: '',
            titularCPF: '',
          },
        },
        jobDetails: {
          comissionType: 0,
          comissionTypeEnum: 0,
          comissionFloor: 0,
          comissionStep: 0,
          profitFloor: null,
          profitStep: null,
          job: null,
          salary: '',
          salary_to_create: null,
        },
      },
    }
  },
  methods: {
    handleChangeStepper(increment){
      if(increment){
        if(this.$refs[`form${this.stepper}`].validate()){
          if(this.stepper == 4){
            this.submitEmployee()
          }else{
            this.stepper++
          }
        }else{
          this.addNotification({type: 'error',  msg: `Humm.. Alguns campos são necessários.`})
        }
      }else{
        this.stepper--
      }
    },
    prepareUser() {
      this.employee.user_attributes.email = this.employee.contacts.primary.email
    },
    prepareEmployee(){
      this.prepareUser()
      this.employee.jobDetails.salary_to_create = parseFloat(this.employee.jobDetails.salary.replace(/,/g, ''))

      this.employee.contacts_attributes.push(this.employee.contacts.primary)
      if(!!this.employee.contacts.secondary.celphone){
        this.employee.contacts_attributes.push(this.employee.contacts.secondary)
      }
      if(this.employee.jobDetails.job_name == 'Driver'){
        this.employee.driver_attributes = {
          ...this.employee.driver_attributes,
          name: this.employee.user_attributes.name,
          modality_ids: this.employee.modality_ids,
          external: false,
          receipt_config: {
            kind: 'cash',
            kinds: ['cash'],
          },
        }
      }
    },
    resetForm(){
      this.resetEmployee()
      this.stepper = 0
      this.employee.contacts_attributes = [];
      this.employee.accounts_attributes = [];
    },
    submitEmployee() {
      this.swallConfirmation({
        title: `Deseja cadastrar funcionário?`,
        icon: 'question',
      }).then( confirmed =>{
        if ( confirmed ) {
          this.prepareEmployee()
          this.saving = true
          Api.Employee.create(this.employee).then(()=>{
            this.addNotification({type: 'success',  msg: `Funcionário cadastrado com sucesso!`})
            this.resetForm()
          }).catch((err) =>{
              if(err.response?.data?.cpf_in_use || err.response?.data?.email_in_use){
                let msg = err.response.data.cpf_in_use ? 'CPF em uso.' : 'Email em uso.'
                this.addNotification({type: 'error',  msg: msg})
              }else{
                this.addNotification({type: 'error',  msg: err})
              }
            
          }).finally(() => {
            this.saving = false
          })
        }
      })
    },
    resetEmployee(){
      this.employee = {
        status_id: 1,
        manager_id: null,
        team: 'none',
        comissions_attributes: [],
        modality_ids: [],
        goals_attributes: {
          goal: null,
          status_id: 'Set',
          due_date: new Date((new Date).getUTCFullYear(), (new Date).getUTCMonth() + 1, 0).toISOString().substring(0, 10),
          comment: 'Meta ao criar employee',
          kind: null,
          name: null,
          actual_value: 0,
        },
        user_attributes: {
          name: null,
          cpf: null,
          email: null,
          password: '4826#webcimentao@',
          password_confirmation: '4826#webcimentao@',
        },
        address_attributes: {
          zip: '',
          city: '',
          complement: '',
          neighborhood: '',
          addr: '',
          uf: '',
          number: '',
        },
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
        contacts_attributes: [],
        accounts_attributes: [],
        driver_attributes: {
          name: null,
          cnh: null,
          // documents: null,
          truck_id: null,
          external: null,
          status_id: null,
          modality_ids: []
        },
        contacts: {
          primary: {
            email: '',
            phone: '',
            mobile: '',
          },
          secondary: {
            email: '',
            phone: '',
            mobile: '',
          },
        },
        accounts: {
          primary: {
            bank: '',
            agency: '',
            account: '',
            titular: '',
            titularCPF: '',
          },
          secondary: {
            bank: '',
            agency: '',
            account: '',
            titular: '',
            titularCPF: '',
          },
        },
        jobDetails: {
          comissionType: 0,
          comissionTypeEnum: 0,
          comissionFloor: 0,
          comissionStep: 0,
          profitFloor: null,
          profitStep: null,
          job: null,
          salary: '',
          salary_to_create: null,
        },
      }
    },
  },
}
</script>